export default __webpack_public_path__ + "static/media/elePerson_2_2.2cfda7ce.png";